/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../../Services/ApiService";
// import { toastEmmit } from "../../Helper/Toastr";
import "../Login/Login.css";
import video from "../../assets/img/video.mp4";
import { showErrorAlert, showSuccessAlert } from "../../Helper/SweetAlert";
export default function Login() {
  let navigate = useNavigate();

  const [error, setError] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState(false);
  // let [ShowHide, setType] = useState(true);
  let [RememberMe, setRememberMe] = useState();

  const [submitLoader, setsubmitLoader] = useState(false);

  useEffect(() => {
    const Udata = JSON.parse(localStorage.getItem("AdminData"));

    if (Udata) {
      setRememberMe(true);
      // setFormData(Udata);
      setEmail(Udata?.email);
      setPassword(Udata?.password);
    }

    if (localStorage.getItem("Atoken")) {
      navigate("/panel/dashboard");
    } else {
      navigate("/login");
    }
  }, []);

  const submitForm = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      setError(true);
      return;
    }

    setsubmitLoader(true);

    const Data = {
      email: email,
      password: password,
    };

    if (RememberMe === true) {
      localStorage.setItem(
        "AdminData",
        JSON.stringify({ email: email, password: password })
      );
    } else {
      localStorage.removeItem("AdminData");
    }

    await axios.post(API_URL.ADMIN_LOGIN, Data).then(
      (res) => {
        console.log(res);
        if (res?.data?.status === true) {
          showSuccessAlert(res?.data?.message , () => {
            localStorage.setItem("Atoken", res?.data?.data.accessToken);
            setsubmitLoader(false);
            navigate("/panel/dashboard");
            window.location.reload();
          });   
          // localStorage.setItem("token", res?.data?.data.accessToken);
          // setsubmitLoader(false);
          // navigate("/panel/dashboard");
          // window.location.reload();
        } else {
          setsubmitLoader(false);
          showErrorAlert(res.data?.message);
        }
      },
      (err) => {
        console.log(err)
        setsubmitLoader(false);
        showErrorAlert(err.response?.data?.message);
      }
    );
  };

  const changeEmail = (e) => {
    if (!e.includes("@")) {
      setEmailError(true);
    } else {
      setEmailError(false);
    }
    return setEmail(e);
  };

  return (
    <>
      <div className="container-fluid page-body-wrapper full-page-wrapper">
        <div className="content-wrapper d-flex align-items-center auth px-0">
          <div className="background-video">
            <video autoPlay loop muted>
              <source src={video} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
          <div className="row w-100 mx-0">
            <div className="col-lg-4 col-md-6 col-sm-8 mx-auto">
              <div
                className="auth-form-light text-center py-5 px-4 px-sm-5"
                style={{ borderRadius: "25px" }}
              >
                <div className="brand-logo">
                  <img src="../../images/logo.png" alt="logo" />
                </div>
                <h4>Hello! let's get started</h4>
                <h6 className="font-weight-light">Sign in to continue.</h6>
                <form
                  className="pt-3"
                  onSubmit={(e) => {
                    submitForm(e);
                  }}
                >
                  <div>
                    <div className="form-group">
                      <input
                        type="email"
                        className="form-control pl-3 rounded"
                        id="exampleInputEmail1"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => changeEmail(e.target.value)}
                      />
                      {!email && error && (
                        <div className="error">Email is required</div>
                      )}
                      {emailError && email && (
                        <div className="error">Invalid Email Format</div>
                      )}
                    </div>
                  </div>

                  <div>
                    <div className="form-group">
                      <input
                        type="password"
                        className="form-control pl-3 rounded"
                        id="exampleInputPassword1"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                      {error && !password && (
                        <div className="error  ">Password is required</div>
                      )}
                    </div>
                  </div>

                  <div className="mt-3">
                    <button
                      type="submit"
                      className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn"
                      disabled={submitLoader}
                    >
                      {submitLoader ? (
                        <i className="fas fa-spinner fa-spin"></i>
                      ) : (
                        "SIGN IN"
                      )}
                    </button>
                    {/* <a
                      className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn"
                      href="../../index.html"
                    >
                      SIGN IN
                    </a> */}
                  </div>
                  <div className="my-2 d-flex justify-content-between align-items-center">
                    <div className="form-check">
                      <label className="form-check-label text-muted">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          checked={RememberMe}
                          onChange={(e) => setRememberMe(e.target.checked)}
                        />
                        Keep me signed in
                        <i className="input-helper" />
                      </label>
                    </div>
                    <Link
                      to={"/forgot-password"}
                      className="auth-link text-black"
                    >
                      Forgot password?
                    </Link>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
